const prompts = [
  "[Add your relevant qualifications or education.]",
  "[Add your relevant skills and supporting examples.]",
  "[Explain your interest in this role and how your experience relates to it.]",
];
const normalize = (value) => value.replace(/\s+/g, " ").toLowerCase();
export function hasGeneratedPrompts(letter) {
  if (typeof letter !== "string") return false;
  const text = normalize(letter);
  return prompts.some((prompt) => text.includes(normalize(prompt)));
}
